export function initials(user) {
  const name = String(user?.displayName || user?.email || '').replace(/@.*/, '')
  const words = name.split(/[^\p{L}\p{N}]+/u).filter(Boolean)
  if (words.length > 1) return (words[0][0] + words[1][0]).toUpperCase()
  return words.length ? words[0].slice(0, 2).toUpperCase() : '·'
}
